import { makeRequest } from '@services/requests/makeRequest';
import { USER_ACTION_LOGS } from '@services/requests/requestResources';

export const getListInformation = () =>
  makeRequest('GET', `${USER_ACTION_LOGS}/info`);
